import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Tooltip from "@mui/material/Tooltip";
import Button from "../../common/components/Button";
import Collapse from "@mui/material/Collapse";
import { IoIosCloseCircle } from "react-icons/io";
import { MdExpandLess } from "react-icons/md";
import { MdExpandMore } from "react-icons/md";
import { FaUserNurse } from "react-icons/fa6";
import { BiTask } from "react-icons/bi";
import { FaCheckCircle, FaUserCircle } from "react-icons/fa";
import { IoMdLogOut } from "react-icons/io";
import { FaUsersCog } from "react-icons/fa";
import { MdNotes } from "react-icons/md";
import { BsChatLeftText } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import Confirmation from "../../common/components/Confirmation";
import * as APIService from "../../common/api/index.js";
import URL from "../../common/api/ConstantURL";
import { getSessionContext } from "../../common/utils/sessionContext";
import { removeManyFromLocalStorage, setManyToLocalStorage } from "../../common/utils/localStorage";
import AlertMessage from "../../common/components/AlertMessage";
import Backdrop from "@mui/material/Backdrop";
import { BsFillHeartPulseFill } from "react-icons/bs";
import { useLocation } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { performSessionLogout } from "../../common/utils/authSession";

export default function SwipeableTemporaryDrawer(props) {
  const { caregiverCheckinId, residentId, communityId, residentName, appVersion } = getSessionContext();
  const location = useLocation();
  const showResidentMenu = caregiverCheckinId;
  const isSelectCommunityPage = location.pathname === "/select-community";
  const [state, setState] = useState({
    top: false,
    left: true,
    bottom: false,
    right: false,
  });

  const [residentOpen, setResidentOpen] = useState(Boolean(showResidentMenu) && !isSelectCommunityPage);
  const [caregiverOpen, setCaregiverOpen] = useState(!showResidentMenu && !isSelectCommunityPage);
  const [communitiesOpen, setCommunitiesOpen] = useState(isSelectCommunityPage ? true : false);
  const [showTodoPopup, setShowTodoPopup] = useState(false);
  const [showCheckoutPopup, setShowCheckoutPopup] = useState(false);
  const [alertStatus, setAlertStatusBase] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (isSelectCommunityPage) {
      setCaregiverOpen(false);
      setResidentOpen(false);
      return;
    }
    const hasResidentContext = Boolean(showResidentMenu);
    setCaregiverOpen(!hasResidentContext);
    setResidentOpen(hasResidentContext);
  }, [showResidentMenu, isSelectCommunityPage]);

  const handleClick = (name) => {
    if (caregiverOpen && name == "caregiver") {
      setCaregiverOpen(false);
    } else if (!caregiverOpen && name == "caregiver") {
      setCaregiverOpen(true);
    } else if (residentOpen && name == "resident") {
      setResidentOpen(false);
    } else if (!residentOpen && name == "resident") {
      setResidentOpen(true);
    }
  };

  const handleChangePage = (page) => {
    const pageName = "/" + page;
    navigate(pageName);
  };

  const selectCommunity = (community) => {
    if (!community) {
      return;
    }
    const currentCommunityId = communityId;
    const isCommunityChanged = String(currentCommunityId) !== String(community.id);
    if (isCommunityChanged) {
      removeManyFromLocalStorage(["ResidentInfo", "ResidentName", "ResidentId", "roomNumber", "CaregiverCheckinId", "CheckinTime", "shiftId"]);
    }
    setManyToLocalStorage({
      communityId: community.id,
      communityName: community.communityName,
    });
    props?.showHamBergIcon?.();
    navigate("/home");
  };

  const toggleDrawer = (anchor, open) => (event) => {
    if (event && event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const openTodo = () => {
    setShowTodoPopup(true);
  };

  const openCheckoutTodo = () => {
    setShowCheckoutPopup(true);
  };

  const closeTodoConfirmation = () => {
    setShowTodoPopup(false);
  };

  const confirmationCallback = (e) => {
    e.preventDefault();
    logOut();
  };

  const closeCheckoutConfirmation = () => {
    setShowCheckoutPopup(false);
  };

  const confirmationCheckoutCallback = async (e) => {
    e.preventDefault();
    setShowTodoPopup(false);
    setLoading(true);

    const data = {
      caregiverCheckinId,
    };
    try {
      const responseData = await APIService.postData(URL.caregiverCheckout, data);
      if (responseData.code == 200) {
        removeManyFromLocalStorage(["ResidentName", "ResidentId", "roomNumber", "CaregiverCheckinId", "CheckinTime", "shiftId"]);

        props.showHamBergIcon();
        navigate("/home");
      } else {
        setAlertStatusBase({
          message: responseData.message,
          status: responseData.code,
          origin: "center",
        });
      }

      setLoading(false);
    } catch (error) {
      Sentry.captureException(error);
      setLoading(false);

      setAlertStatusBase({
        message: "Error while checkin resident",
        status: "400",
        origin: "center",
      });
    }
  };

  const logOut = async () => {
    setLoading(true);
    const isNativeWebView = Boolean(window.flutter_inappwebview?.callHandler);
    await performSessionLogout({ navigate: isNativeWebView ? undefined : navigate });
    setLoading(false);
  };

  const closeAlert = () => {
    setAlertStatusBase("");
  };

  const list = (anchor) => (
    <Box sx={{ width: 370, height: "100%" }} role="presentation">
      <Backdrop sx={{ color: "#ffba30", zIndex: (theme) => theme.zIndex.drawer + 1000 }} open={loading}>
        <img src={require("../../assets/btTree.png")} className="loading-img" />
      </Backdrop>
      {alertStatus ? <AlertMessage status={alertStatus.status} message={alertStatus.message} origin={alertStatus.origin} closeAlert={closeAlert} /> : null}

      <List className="sidebar-header">
        <div className="logo-sidebar">
          <img src={require("../../assets/footer-BTName.png")} alt="" />
        </div>
        <div className="close-icon">
          <Tooltip title="Close Menu" arrow>
            <span>
              <IoIosCloseCircle className="close-icon-inner" onClick={props.showHamBergIcon} />
            </span>
          </Tooltip>
        </div>
      </List>
      <List className="sidebar-menu">
        {!isSelectCommunityPage ? (
          <>
            <ListItem key="caregiver-menu" disablePadding>
              <ListItemButton onClick={() => handleClick("caregiver")}>
                <ListItemIcon>
                  <FaUserNurse className="caregiver-sidemenu-icon" />
                </ListItemIcon>
                <ListItemText primary="Caregiver" className="sidebar-menu-text" />
                {caregiverOpen ? <MdExpandLess className="caregiver-sidemenu-icon" /> : <MdExpandMore className="caregiver-sidemenu-icon" />}
              </ListItemButton>
            </ListItem>
            <Divider className="menu-line" />

            <Collapse in={caregiverOpen} timeout="auto" className="collapse" unmountOnExit>
              <ListItem key="caregiver-profile-menu" disablePadding onClick={() => handleChangePage("caregiver-profile")}>
                <ListItemButton>
                  <ListItemIcon>
                    <FaUserCircle className="caregiver-sidemenu-icon" />
                  </ListItemIcon>
                  <ListItemText primary="Profile" className="sidebar-menu-text" />
                </ListItemButton>
              </ListItem>
              <Divider className="menu-line" />
              <ListItem key="caregiver-task-menu" disablePadding onClick={() => handleChangePage("caregiver-task")}>
                <ListItemButton>
                  <ListItemIcon>
                    <BiTask className="caregiver-sidemenu-icon" />
                  </ListItemIcon>
                  <ListItemText primary="Task" className="sidebar-menu-text" />
                </ListItemButton>
              </ListItem>
              <Divider className="menu-line" />
              <ListItem key="caregiver-notes-menu" disablePadding onClick={() => handleChangePage("all-notes")}>
                <ListItemButton>
                  <ListItemIcon>
                    <BsChatLeftText className="caregiver-sidemenu-icon" />
                  </ListItemIcon>
                  <ListItemText primary="Notes" className="sidebar-menu-text" />
                </ListItemButton>
              </ListItem>
              <Divider className="menu-line" />
              {!residentId ? (
                <>
                  <ListItem key="caregiver-checkin-menu" disablePadding onClick={() => handleChangePage("checkin")}>
                    <ListItemButton>
                      <ListItemIcon>
                        <FaCheckCircle className="caregiver-sidemenu-icon" />
                      </ListItemIcon>
                      <ListItemText primary="Check-In" className="sidebar-menu-text" />
                    </ListItemButton>
                  </ListItem>
                  <Divider className="menu-line" />
                </>
              ) : null}
            </Collapse>
            {showResidentMenu != null ? (
              <>
                <ListItem key="resident-menu" disablePadding onClick={() => handleClick("resident")}>
                  <ListItemButton>
                    <ListItemIcon>
                      <FaUsersCog className="caregiver-sidemenu-icon" />
                    </ListItemIcon>
                    <ListItemText primary="Resident" className="sidebar-menu-text" />
                    {residentOpen ? <MdExpandLess className="caregiver-sidemenu-icon" /> : <MdExpandMore className="caregiver-sidemenu-icon" />}
                  </ListItemButton>
                </ListItem>
                <Divider className="menu-line" />

                <Collapse in={residentOpen} timeout="auto" className="collapse" unmountOnExit>
                  <ListItem key="resident-task-menu" disablePadding onClick={() => handleChangePage("resident-task")}>
                    <ListItemButton>
                      <ListItemIcon>
                        <BiTask className="caregiver-sidemenu-icon" />
                      </ListItemIcon>
                      <ListItemText primary="Task" className="sidebar-menu-text" />
                    </ListItemButton>
                  </ListItem>
                  <Divider className="menu-line" />

                  <ListItem key="resident-vitals-menu" disablePadding onClick={() => handleChangePage("vitals")}>
                    <ListItemButton>
                      <ListItemIcon>
                        <BsFillHeartPulseFill className="caregiver-sidemenu-icon" />
                      </ListItemIcon>
                      <ListItemText primary="Vitals" className="sidebar-menu-text" />
                    </ListItemButton>
                  </ListItem>
                  <Divider className="menu-line" />
                  <ListItem key="resident-client-info-menu" disablePadding onClick={() => handleChangePage("resident-notes")}>
                    <ListItemButton>
                      <ListItemIcon>
                        <MdNotes className="caregiver-sidemenu-icon" />
                      </ListItemIcon>
                      <ListItemText primary="Basic Info" className="sidebar-menu-text" />
                    </ListItemButton>
                  </ListItem>
                  <Divider className="menu-line" />
                  <ListItem key="resident-notes-menu" disablePadding onClick={() => handleChangePage("notes")}>
                    <ListItemButton>
                      <ListItemIcon>
                        <BsChatLeftText className="caregiver-sidemenu-icon" />
                      </ListItemIcon>
                      <ListItemText primary="Notes" className="sidebar-menu-text" />
                    </ListItemButton>
                  </ListItem>
                  <Divider className="menu-line" />
                  <ListItem key="resident-checkout-menu" disablePadding onClick={openCheckoutTodo}>
                    <ListItemButton>
                      <ListItemIcon>
                        <IoMdLogOut className="caregiver-sidemenu-icon" />
                      </ListItemIcon>
                      <ListItemText primary="Check-Out" className="sidebar-menu-text" />
                    </ListItemButton>
                  </ListItem>
                  <Divider className="menu-line" />
                </Collapse>
              </>
            ) : null}
          </>
        ) : (
          <>
            <ListItem disablePadding>
              <ListItemButton onClick={() => setCommunitiesOpen((p) => !p)}>
                <ListItemIcon>
                  <FaUsersCog className="caregiver-sidemenu-icon" />
                </ListItemIcon>
                <ListItemText primary="Communities" className="sidebar-menu-text" />
                {communitiesOpen ? <MdExpandLess className="caregiver-sidemenu-icon" /> : <MdExpandMore className="caregiver-sidemenu-icon" />}
              </ListItemButton>
            </ListItem>
            <Divider className="menu-line" />

            <Collapse in={communitiesOpen} timeout="auto" className="collapse" unmountOnExit>
              {Array.isArray(props?.communities) && props.communities.length > 0 ? (
                props.communities.map((community) => (
                  <React.Fragment key={community.id}>
                    <ListItem disablePadding onClick={() => selectCommunity(community)} className="community-item">
                      <ListItemButton>
                        <ListItemIcon>
                          <FaCheckCircle className={`caregiver-sidemenu-icon community-check-icon ${communityId == community.id ? "is-selected" : "is-dimmed"}`} />
                        </ListItemIcon>
                        <ListItemText primary={community.communityName} className="sidebar-menu-text" />
                      </ListItemButton>
                    </ListItem>
                    <Divider className="menu-line" />
                  </React.Fragment>
                ))
              ) : (
                <ListItem disablePadding>
                  <ListItemButton>
                    <ListItemText primary="No Communities Available" className="sidebar-menu-text" />
                  </ListItemButton>
                </ListItem>
              )}
            </Collapse>
          </>
        )}
      </List>
      <Confirmation content="Are you sure you want to logout?" open={showTodoPopup} closeConfirmation={(data) => closeTodoConfirmation(data)} processCallback={(data) => confirmationCallback(data)} />
      <div className="header-menu-button">
        <Button name="submit" label="LOGOUT" className="ccar-logout-button" onClick={openTodo} />
      </div>
      <div className="sidebar-version">Version {appVersion || "2.0.0"}</div>
      <Confirmation username={residentName} content="Are you sure you want to check-out?" open={showCheckoutPopup} closeConfirmation={(data) => closeCheckoutConfirmation(data)} processCallback={(data) => confirmationCheckoutCallback(data)} />
    </Box>
  );

  return (
    <div>
      {["left", "right", "top", "bottom"].map((anchor) => (
        <React.Fragment key={anchor}>
          <SwipeableDrawer anchor={anchor} open={state[anchor]} onClose={props.showHamBergIcon} onOpen={toggleDrawer(anchor, true)}>
            {list("left")}
          </SwipeableDrawer>
        </React.Fragment>
      ))}
    </div>
  );
}
